export interface Workbook {
  number: string;
  title: string;
  subtitle: string;
  description: string;
  tag: string;
  coverImage: string;
}

export const workbooks: Workbook[] = [
  {
    number: '01',
    title: 'MATERIA E TRASFORMAZIONI',
    subtitle: 'Proprietà, stati, miscele, soluzioni e trasformazioni della materia',
    description:
      'Un volume visivo e pronto per la classe dedicato alle proprietà della materia, agli stati di aggregazione, ai modelli particellari, alle sostanze pure, alle miscele, alle soluzioni e alle trasformazioni fisiche e chimiche. Aiuta gli studenti a passare dall’osservazione macroscopica all’interpretazione particellare e simbolica dei fenomeni.',
    tag: '60 pagine · Teoria visiva · Attività · Laboratori · Verifiche A/B · Soluzioni',
    coverImage:
      'https://cdn.magicpatterns.com/uploads/r9E8kv3tYh3N78z3amtRiH/13f80f93-bb10-4839-9870-8d45a3e711db.webp',
  },
  {
    number: '02',
    title: 'STRUTTURA ATOMICA E PERIODICITÀ',
    subtitle: 'Atomi, isotopi, configurazione elettronica e proprietà periodiche',
    description:
      'Costruisce una comprensione progressiva della struttura atomica, degli isotopi, degli ioni, della configurazione elettronica, degli elettroni di valenza e dell’organizzazione della tavola periodica. Include attività visive e guidate per interpretare le proprietà periodiche senza ridurle a definizioni da memorizzare.',
    tag: '60 pagine · Teoria visiva · Attività · Laboratori · Verifiche A/B · Soluzioni',
    coverImage:
      'https://cdn.magicpatterns.com/uploads/bYJaCbpRnUMhiZschZSF55/b228096e-aaf4-4464-b1e5-ce1c74da0ed7.webp',
  },
  {
    number: '03',
    title: 'LEGAMI CHIMICI E STRUTTURA MOLECOLARE',
    subtitle: 'Strutture di Lewis, geometria, polarità e forze intermolecolari',
    description:
      'Accompagna gli studenti dalla configurazione elettronica alla comprensione dei legami ionici, covalenti e metallici. Comprende strutture di Lewis, carica formale, risonanza, teoria VSEPR, geometria molecolare, polarità e forze intermolecolari.',
    tag: '60 pagine · Teoria visiva · Attività · Laboratori · Verifiche A/B · Soluzioni',
    coverImage:
      'https://cdn.magicpatterns.com/uploads/wZu7ZCFrAXRujqr6gqDXgL/ChatGPT-Image-6-ago-2026_-09_03_27-p.m..webp',
  },
  {
    number: '04',
    title: 'REAZIONI CHIMICHE E STECHIOMETRIA',
    subtitle: 'Nomenclatura, equazioni, mole, calcoli ed energia delle trasformazioni',
    description:
      'Un percorso completo che collega formule, nomenclatura, equazioni chimiche e descrizione quantitativa delle trasformazioni. Comprende bilanciamento, mole, massa molare, rapporti stechiometrici, reagente limitante, resa, purezza, soluzioni, gas, energia, velocità di reazione ed equilibrio chimico.',
    tag: '60 pagine · Teoria visiva · Attività · Laboratori · Verifiche A/B · Soluzioni',
    coverImage:
      'https://cdn.magicpatterns.com/uploads/uAZe1ZqV161ac5hrcPSQhW/ChatGPT-Image-6-ago-2026_-09_03_21-p.m..webp',
  },
  {
    number: '05',
    title: 'CHIMICA ORGANICA E BIOSISTEMI',
    subtitle: 'Carbonio, gruppi funzionali, polimeri, biomolecole e sostenibilità',
    description:
      'Introduce la chimica del carbonio attraverso strutture, nomenclatura, isomeria, proprietà e trasformazioni fondamentali. Comprende idrocarburi, gruppi funzionali, polimeri, carboidrati, lipidi, proteine, acidi nucleici, enzimi, chimica ambientale e criteri di chimica verde.',
    tag: '60 pagine · Teoria visiva · Attività · Laboratori · Verifiche A/B · Soluzioni',
    coverImage:
      'https://cdn.magicpatterns.com/uploads/r6YZhjQympgw4eUkFsN31H/ChatGPT-Image-6-ago-2026_-09_03_15-p.m..webp',
  },
];

export interface Bonus {
  badge: string;
  icon: string;
  title: string;
  subtitle: string;
  description: string;
  pages: string;
  value: string;
}

export const bonuses: Bonus[] = [
  {
    badge: 'BONUS 1',
    icon: '🎲',
    title: 'CHIMICA IN GIOCO™',
    subtitle: 'Carte, giochi, sfide ed escape room per il ripasso',
    description:
      'Una raccolta di giochi didattici completi, pronti da stampare, ritagliare e utilizzare. Comprende domino chimico, bingo degli elementi, memory, giochi “Chi sono?”, vero o falso, sfide di classificazione, carte della nomenclatura, corsa al bilanciamento, missioni di stechiometria, duello del pH e mini escape room.',
    pages: '48 pagine',
    value: '47 €',
  },
  {
    badge: 'BONUS 2',
    icon: '🔬',
    title: 'CHIMICA IN AZIONE™',
    subtitle: 'Progetti scientifici visivi pronti per la classe',
    description:
      'Dieci progetti completi che trasformano i concetti teorici in domande investigabili, misure, dati e conclusioni. Ogni progetto comprende domanda di ricerca, ipotesi, variabili, materiali, sicurezza, procedimento, tabelle, grafici, analisi, conclusione e comunicazione finale.',
    pages: '48 pagine',
    value: '47 €',
  },
  {
    badge: 'BONUS 3',
    icon: '📋',
    title: 'VALUTAZIONE FORMATIVA™',
    subtitle: 'Exit ticket, quiz, rubriche e strumenti di monitoraggio',
    description:
      'Un sistema completo per verificare rapidamente che cosa gli studenti hanno compreso e quali concetti devono essere ripresi. Comprende verifiche diagnostiche, exit ticket, quiz da 5 e 10 minuti, attività di analisi degli errori, autovalutazioni, rubriche e griglie di monitoraggio.',
    pages: '60 pagine',
    value: '47 €',
  },
  {
    badge: 'BONUS 4',
    icon: '📚',
    title: 'AULA DI CHIMICA VISIVA™',
    subtitle: 'Poster, tavole di consultazione e carte visive',
    description:
      'Una biblioteca visiva da proiettare, stampare, esporre o distribuire agli studenti. Comprende materiali dedicati alla materia, alla struttura atomica, alla tavola periodica, ai legami, alla nomenclatura, alla stechiometria, al pH, alla chimica organica, alle biomolecole e alla sicurezza.',
    pages: '48 pagine',
    value: '47 €',
  },
];

export interface Testimonial {
  text: string;
  name: string;
  city: string;
  role: string;
  initials: string;
}

export const testimonials: Testimonial[] = [
  {
    text: 'Quello che apprezzo di più è il tempo che riesco a risparmiare nella preparazione. Prima di una lezione mi capitava di cercare schede, esercizi e immagini in fonti diverse. Con un materiale già organizzato posso scegliere ciò che mi serve e concentrarmi molto di più sulla lezione e sulla classe.',
    name: 'Elena R.',
    city: 'Milano',
    role: 'Docente di Chimica',
    initials: 'ER',
  },
  {
    text: 'La parte visuale è particolarmente utile quando devo spiegare argomenti come struttura atomica, legami o reazioni. Avere schemi chiari davanti agli studenti rende la spiegazione più immediata e mi permette di richiamare velocemente i concetti anche durante il ripasso.',
    name: 'Marco B.',
    city: 'Bologna',
    role: 'Docente di Chimica e Scienze',
    initials: 'MB',
  },
  {
    text: 'Le verifiche in più versioni e le relative soluzioni sono strumenti che possono semplificare parecchio l’organizzazione, soprattutto quando si lavora con più classi. Anche durante la correzione avere già un riferimento chiaro permette di lavorare in modo molto più ordinato.',
    name: 'Giulia F.',
    city: 'Torino',
    role: 'Docente di Chimica',
    initials: 'GF',
  },
  {
    text: 'Mi piace soprattutto la possibilità di scegliere il materiale in base alla classe. Una volta può servirmi una spiegazione, un’altra una scheda, un’attività oppure una verifica. Avere tutto suddiviso per argomento rende molto più semplice trovare rapidamente ciò che serve.',
    name: 'Francesca C.',
    city: 'Firenze',
    role: 'Docente di Chimica',
    initials: 'FC',
  },
  {
    text: 'Le attività permettono di passare dalla spiegazione alla pratica senza dover preparare ogni volta tutto da zero. Sono utili anche per capire abbastanza rapidamente se gli studenti hanno davvero assimilato il concetto e quali aspetti invece devono essere ripresi.',
    name: 'Luca D.',
    city: 'Napoli',
    role: 'Docente di Chimica',
    initials: 'LD',
  },
  {
    text: 'I giochi e le attività più dinamiche possono funzionare molto bene nei momenti di ripasso. Cambia il ritmo della lezione, ma i contenuti di chimica rimangono centrali. È anche un modo interessante per coinvolgere studenti che normalmente partecipano meno.',
    name: 'Sara M.',
    city: 'Verona',
    role: 'Docente di Scienze e Chimica',
    initials: 'SM',
  },
  {
    text: 'I poster e le tavole visuali sono molto pratici durante le spiegazioni e quando bisogna recuperare velocemente un concetto già affrontato. La cosa importante è che siano chiari e non sovraccarichi di informazioni, così gli studenti riescono davvero a utilizzarli come riferimento.',
    name: 'Alessandro G.',
    city: 'Roma',
    role: 'Docente di Chimica',
    initials: 'AG',
  },
];

export interface Highlight {
  title: string;
  detail: string;
}

/**
 * Promemoria informativi mostrati nel riquadro flottante.
 * Contengono solo caratteristiche verificabili del prodotto, nessun dato di acquisto.
 */
export const highlights: Highlight[] = [
  {
    title: 'Accesso digitale immediato',
    detail: 'Ricevi i materiali via e-mail subito dopo l’acquisto.',
  },
  {
    title: 'Pagamento unico',
    detail: 'Nessun abbonamento mensile e nessun rinnovo automatico.',
  },
  {
    title: '504 pagine pronte da stampare',
    detail: '5 volumi completi e 4 bonus professionali.',
  },
  {
    title: 'Materiali interamente in italiano',
    detail: 'Pensati per la scuola secondaria di secondo grado.',
  },
  {
    title: 'Soluzioni per il docente incluse',
    detail: 'Verifiche A/B con relative correzioni.',
  },
  {
    title: 'Garanzia di rimborso di 7 giorni',
    detail: 'Esplora i materiali con tranquillità.',
  },
];

export interface Faq {
  question: string;
  answer: string;
}

export const faqs: Faq[] = [
  {
    question: 'Ho già alcuni materiali di chimica. CHIMICA VISIVA™ può essermi utile comunque?',
    answer:
      'Sì. Non devi sostituire ciò che utilizzi già. Puoi usare CHIMICA VISIVA™ come sistema completo oppure integrare soltanto le unità, le attività, le verifiche e le risorse che ti servono.',
  },
  {
    question: 'È solo una raccolta di schede?',
    answer:
      'No. CHIMICA VISIVA™ è un sistema didattico organizzato che combina teoria visiva, attività, esercizi, strumenti di verifica, soluzioni e risorse complementari per accompagnare diversi momenti della lezione.',
  },
  {
    question: 'Che cosa riceverò esattamente?',
    answer:
      'Riceverai l’accesso digitale ai cinque volumi di CHIMICA VISIVA™ e ai quattro bonus professionali: 504 pagine complessive in PDF, con schede teoriche visive, attività, laboratori, verifiche A/B, soluzioni per il docente, giochi, progetti scientifici, strumenti di valutazione e materiali da esporre in aula.',
  },
  {
    question: 'Si tratta di un prodotto fisico?',
    answer:
      'No. CHIMICA VISIVA™ è un prodotto interamente digitale: non verrà spedito alcun materiale fisico.',
  },
  {
    question: 'Come riceverò i materiali?',
    answer:
      'Al termine dell’acquisto riceverai l’accesso all’indirizzo e-mail indicato durante il pagamento. Ti consigliamo di controllare anche le cartelle spam e promozioni.',
  },
  {
    question: 'Devo pagare un abbonamento mensile?',
    answer:
      'No. Si tratta di un pagamento unico. Non esistono abbonamenti mensili né rinnovi automatici.',
  },
  {
    question: 'Per quanto tempo potrò utilizzare i materiali?',
    answer:
      'L’accesso ai materiali digitali inclusi nell’offerta non ha scadenza: potrai utilizzarli anno dopo anno.',
  },
  {
    question: 'Sono incluse le soluzioni?',
    answer:
      'Sì. Le soluzioni per il docente sono incluse per le attività e per le verifiche A/B corrispondenti.',
  },
  {
    question: 'Per quali classi è stato progettato?',
    answer:
      'I materiali sono pensati principalmente per la chimica nella scuola secondaria di secondo grado e possono essere adattati a livelli e programmi diversi.',
  },
  {
    question: 'Posso utilizzare i materiali con i miei studenti?',
    answer:
      'Sì. La licenza è individuale e prevede l’utilizzo nelle classi del docente che effettua l’acquisto. La redistribuzione, la condivisione integrale e la rivendita dei materiali non sono consentite.',
  },
  {
    question: 'I materiali sono interamente in italiano?',
    answer: 'Sì. Testi, attività, verifiche e soluzioni sono interamente in italiano.',
  },
  {
    question: 'Posso utilizzare solo alcune pagine?',
    answer:
      'Certamente. Ogni volume è organizzato per argomento: puoi stampare o proiettare solo le pagine utili alla lezione del giorno.',
  },
  {
    question: 'È necessario installare un’applicazione?',
    answer:
      'No. I file sono in formato PDF e si aprono su qualsiasi computer, tablet o telefono, senza applicazioni obbligatorie.',
  },
  {
    question: 'Posso richiedere un rimborso?',
    answer:
      'Sì. Puoi contattarci entro sette giorni dall’acquisto e richiedere il rimborso secondo le condizioni indicate nella nostra politica di rimborso.',
  },
];
